import styled from 'styled-components';

export const StyledBroadsiderHomeHudBanner = styled.div`
  max-width: 30rem;
  min-width: 17rem;
  padding-top: 2rem;
  padding-left: 2rem;
  position: relative;

  .broadsider-home-banner-logo-container {
    width: 4.5rem;
    height: 4.5rem;
    background: rgba(253, 173, 50, 1);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .broadsider-home-banner-logo {
    width: 3rem;
    height: 3rem;
  }

  .broadsider-home-banner-main-text {
    text-transform: uppercase;
    font-family: "NeueMachina";
    font-size: 3rem;
    padding-top: 1rem;
  }

  .broadsider-home-banner-main-text-selected {
    font-weight: 700;
  }

  .broadsider-home-banner-secondary-text {
    color: rgba(254, 191, 75, 1);
    font-family: "BebasNeue";
    text-transform: uppercase;
    font-weight: 700;
    font-size: 1.875rem;
    padding-top: 1rem;
  }
`;

